<template>
  <div class="layout-statistics">
    <div class="layout-header" :class="$globalConfig.headerOpen ? '':'header-close'">
      <app-header>
        <app-menu ref="appMenu" slot="app-menu"></app-menu>
      </app-header>
    </div>
    <div class="layout-body">
      <app-sidebar class="layout-side"
                   :class="$globalConfig.headerOpen ? '':'header-close'"
                   :menu="sideBarMenu"
                   :select="sideBarMenuCurrentItem"
                   @select="handleSelectSideBarMenuItem">
      </app-sidebar>
      <div class="layout-main" :class="$globalConfig.headerOpen ? '' + (sideBarOpen ? '':'side-bar-close'):'header-close' + (sideBarOpen ? '':' side-bar-close')">
        <app-breadcrumb class="layout-breadcrumb" :class="$globalConfig.headerOpen ? '' + (sideBarOpen ? '':'side-bar-close'):'header-close' + (sideBarOpen ? '':' side-bar-close')" :breadcrumb="breadcrumb"></app-breadcrumb>
        <div class="layout-content"  :class="$globalConfig.headerOpen ? ($globalConfig.fullScreen ? 'full-screen':''):'header-close' + ($globalConfig.fullScreen ? ' full-screen':'')">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import LayoutStatistics from './LayoutStatistics.js'
export default LayoutStatistics
</script>

<style lang="scss">
@import "LayoutStatistics";
</style>



// WEBPACK FOOTER //
// src/layouts/layoutStatistics/LayoutStatistics.vue